module.exports = __webpack_public_path__ + "img/sport.10a1ab63.png";